module.exports = __webpack_public_path__ + "static/media/bar_icon.cc031ea2.svg";